import React, { Component } from "react";
import {
    Button, TextField, Thumbnail, Modal, BlockStack, DataTable, Spinner, Banner,
} from "@shopify/polaris";
import { 
    reqPostmanualBulkEditAction, 
    reqGetPageDetailData 
} from '../../../../../../api';
import ToastFunc from "../../../../../../components/ToastFunc";
import './index.css';
import Language from '../../../../../../i18n/Language';
import FreeTagInputMix from "../../../../../../components/FreeTagInput";
import FreeTagInputTraceless from "../../../../../../components/FreeTagInput/indexV2";
import cloneDeep from 'lodash-es/cloneDeep';
import { showNewMessage } from '@intercom/messenger-js-sdk';
import utils from "../../../../../../utils/utils";
const t = Language;

class OptimizeImageAlt extends Component {

    constructor(props) {
        super(props);
        this.state = {
            modalActive: props.active ? true : false,
            updateImageLoading: true,

            imageTbaleTrRow: [],
            // alt模板应用值
            applyAllValue: '',

            //弹窗
            showToast: false, //弹窗显示
            showToastText: "", //弹窗文字
            showToastIserror: false, //弹窗是否错误

            altModalOpen: props.altModalOpen,

            //数据加载
            dataLoading: true,

            //初始化参数
            targetId: this.props.TargetId,
            blogId: 0,
            collectionType: '',

            allImagesArr: [],
            isShowSelectPop: false,
            defaultTag: '', // 默认tag
            proTagList: [
                {
                    content: '{{Product title}}',
                    onAction: () => this.addApplyField('Product title', 'FixTagContent')
                },
                {
                    content: '{{Product vendor}}',
                    onAction: () => this.addApplyField('Product vendor', 'FixTagContent')
                },
                {
                    content: '{{Product type}}',
                    onAction: () => this.addApplyField('Product type', 'FixTagContent')
                },
                {
                    content: '{{Shop name}}',
                    onAction: () => this.addApplyField('Shop name', 'FixTagContent')
                },
            ],
            colTagList: [
                {
                    content: '{{Collection title}}',
                    onAction: () => this.addApplyField('Collection title', 'FixTagContent')
                },
                {
                    content: '{{Shop name}}',
                    onAction: () => this.addApplyField('Shop name', 'FixTagContent')
                }
            ],
            blogTagList: [
                {
                    content: '{{Blog title}}',
                    onAction: () => this.addApplyField('Blog title', 'FixTagContent')
                },
                {
                    content: '{{Shop name}}',
                    onAction: () => this.addApplyField('Shop name', 'FixTagContent')
                }
            ],
            resData: {}, // 对象数据
            applyAllLoading: false,
            tagSet: {},
            FixTagContentPop: false,
            addTagsFix: '',
            isLocalStorage: false,
            tagActive: [],
            emptyId: [], // 空alt 输入框
            isShowEditAltBanner: false, // 编辑弹窗 alt banner
            EditAltBannerTip: '',
            isShowErrorTip: '',
            bulkAltConfig: this.props.bulkAltConfig,
            isCustomize: this.props.isCustomize,
            AllImages: this.props.AllImages,
        };
    }

    UNSAFE_componentWillMount() {
        let isLocalStorage = null;
        try {
            sessionStorage.setItem('localState', 1)
            isLocalStorage = true;
        } catch {
            isLocalStorage = false;
        }
        this.setState({
            isLocalStorage: isLocalStorage,
        })
    }

    //下一次更新数据
    // UNSAFE_componentWillReceiveProps(nextProps) {
    //     this.setState({
    //         modalActive: nextProps.active ? true : false,
    //         targetId: nextProps.TargetId,
    //         updateImageLoading: true,
    //         dataLoading: true,
    //         imageTbaleTrRow: [],
    //         // alt模板应用值
    //         applyAllValue: '',
    //     }, () => {
    //         this.getAltImagesData();
    //     })
    // }

    shouldComponentUpdate(nextProps) {
        if (nextProps.bulkAltConfig !== this.props.bulkAltConfig) {
            this.setState({
                bulkAltConfig: nextProps.bulkAltConfig
            })
        }

        if (nextProps.isCustomize !== this.props.isCustomize) {
            this.setState({
                isCustomize: nextProps.isCustomize
            })
        }

        if (nextProps.AllImages !== this.props.AllImages) {
            this.setState({
                AllImages: nextProps.AllImages
            })
        }

        return true;
    }

    componentDidMount() {
        this.getAltImagesData();
        this.setDefaultTag();
    }

    // 转成tag输入框的数据格式
    setDefaultTagFormat = (data) => {
        let val = "";
        if (Boolean(data) && data !== '') {
            val = cloneDeep(data);
            val = val.replace(/\n/g, '')
            let { SelectType } = this.props;
            if (SelectType === 'product') {
                val = val.replace(/%product_title%/g, '[[{"value":"{{Product title}}"}]]')
                    .replace(/%product_vendor%/g, '[[{"value":"{{Product vendor}}"}]]')
                    .replace(/%product_type%/g, '[[{"value":"{{Product type}}"}]]')
                    .replace(/%shop_name%/g, '[[{"value":"{{Shop name}}"}]]')
            } else if (SelectType === 'collections') {
                val = val.replace(/%collection_title%/g, '[[{"value":"{{Collection title}}"}]]')
                    .replace(/%shop_name%/g, '[[{"value":"{{Shop name}}"}]]')
            } else if (SelectType === 'blog') {
                val = val.replace(/%blog_title%/g, '[[{"value":"{{Blog title}}"}]]')
                    .replace(/%shop_name%/g, '[[{"value":"{{Shop name}}"}]]');
            } else { }
        }
        return val;
    }

    // 设置tag
    setDefaultTag = () => {
        let { SelectType } = this.props;
        let { proTagList, colTagList, blogTagList, bulkAltConfig } = this.state;
        if (SelectType === 'product') {
            // product
            // bulkAltConfig?.product_alt ? this.setDefaultTagFormat(bulkAltConfig.product_alt) : 
            this.setState({
                defaultTag: `[[{"value":"${proTagList[0]['content']}"}]] - [[{"value":"${proTagList[3]['content']}"}]]`
            })
        } else if (SelectType === 'collections') {
            // bulkAltConfig?.collection_alt ? this.setDefaultTagFormat(bulkAltConfig.collection_alt) : 
            this.setState({
                defaultTag: `[[{"value":"${colTagList[0]['content']}"}]] - [[{"value":"${colTagList[1]['content']}"}]]`
            })
        } else if (SelectType === 'blog') {
            // bulkAltConfig?.blog_alt ? this.setDefaultTagFormat(bulkAltConfig.blog_alt) : 
            this.setState({
                defaultTag: `[[{"value":"${blogTagList[0]['content']}"}]] - [[{"value":"${blogTagList[1]['content']}"}]]`
            })
        } else {
            this.setState({
                defaultTag: ''
            })
        }
    }

    /**
   * 获取实时图片数据
   */
    getAltImagesData = async () => {
        var SelectType = this.props.SelectType
        let response = '';
        let { isCustomize, AllImages, targetId } = this.state;

        // page(otherpage) 没有独立的详情接口：直接使用父级传入的图片，
        // 且不回写整页详情，避免覆盖未保存的富文本内容
        if (SelectType === 'otherpage') {
            this.setState({
                allImagesArr: isCustomize ? AllImages : [],
                dataLoading: false,
                updateImageLoading: false,
            }, () => {
                this.updateTableContent();
            });
            return;
        }

        let sourceType = SelectType === 'product' ? 'product' : SelectType === 'collections' ? 'collection' : SelectType === 'blog' ? 'article' : 'page';
        response = await reqGetPageDetailData({
            sourceType,
            id: targetId,
        });

        if (response.code === '200') {
            this.setState({
                resData: response.data,
                allImagesArr: isCustomize ? AllImages : response.data.images,
                dataLoading: false,
                updateImageLoading: false,
                targetId: SelectType === 'blog' ? response.data.article_id : response.data.id,
                blogId: response.data?.blog_id || 0,
                collectionType: response.data?.collection_type || ''
            }, () => {
                this.updateTableContent();
                if (!isCustomize) {
                    this.props.updPageDetailData(response, targetId);
                }
            })
        }

        //接口返回错误显示
        if (response.code !== '200') {
            this.setState({
                modalActive: !this.state.modalActive,
            }, () => {
                // 通知父组件 弹窗已关闭，父组件刷新
                this.setState({
                    updateImageLoading: false,
                })
                this.props.callBackRefresh(response.msg);
            })
        }
    }
    //提示弹窗
    toggleToast = (showToastText, showToastIserror) => {
        this.setState({
            showToast: false
        }, () => {
            this.setState(({ showToast }) => ({
                showToast: !showToast,
                showToastText: showToastText,
                showToastIserror: showToastIserror
            }));
        });
    };

    updateTableContent() {
        let { emptyId, allImagesArr } = this.state;
        let data = allImagesArr;
        if (data.length > 0) {
            const imagesRows = data.map((item, key) => {
                if (item.src !== '') {
                    return ([
                        <div className="Edit_Image_Alt">
                            <Thumbnail source={item.src} alt={item.alt} size="small" />
                        </div>,
                        <div>
                            <TextField
                                id={"alt_text_" + key}
                                value={item.alt}
                                onChange={(value) => this.handleChnageImageAlt(value, key, item)}
                                error={emptyId.includes(item.id) ? t("Alt text content cannot be empty!") : false}
                            />
                        </div>,
                    ]);
                } else {

                    return [];
                }
            });

            // 更新图片列表数据
            this.setState({
                imageTbaleTrRow: imagesRows
            });
        }
    }

    // 修改图片alt文本
    handleChnageImageAlt = (value, recordKey, objs) => {
        let data = this.state.allImagesArr;
        let ids = cloneDeep(this.state.emptyId);
        if (ids.includes(objs.id)) {
            ids.splice(ids.indexOf(objs.id), 1);
        }
        data[recordKey].alt = value;
        this.setState({
            allImagesArr: data,
            emptyId: ids,
        }, () => {
            this.updateTableContent();
        });
    }

    // modal Change
    handleModalChange = () => {
        // this.setState(({modalActive}) => ({modalActive: !modalActive}));
        this.setState({
            modalActive: !this.state.modalActive,
            altModalOpen: !this.state.altModalOpen,
            allImagesArr: [],
            imageTbaleTrRow: [],
            applyAllValue: '',
            emptyId: [],
            tagActive: [],
            isShowEditAltBanner: false,
            EditAltBannerTip: '',

        }, () => {
            this.props.closeAltEditModal();
        });
    }

    // 保存图片ALT
    updateImageAlt = async () => {
        let { isCustomize, allImagesArr } = this.state;
        if (isCustomize) {
            this.props.updateCustomizeAlt(allImagesArr);
        } else {

            this.setState({
                updateImageLoading: true
            }, async () => {
                // //调用更新列表
                let data = this.state.allImagesArr;
                if (data.filter(i => i?.alt === "").length > 0) {
                    let ids = [];
                    data.forEach(i => {
                        if (i?.alt === '') {
                            ids.push(i.id)
                        }
                    })
                    this.setState({
                        emptyId: ids,
                        updateImageLoading: false,
                    }, () => {
                        this.updateTableContent();
                    })
                } else {
                    let idArr = [];
                    let altArr = [];
                    // var isAllAlt = 1;//新增一个alt判断
                    for (let i = 0; i < data.length; i++) {
                        idArr.push(data[i].id);
                        altArr.push(data[i]?.alt || '');
                        // if (data[i]?.alt === '') {
                        // isAllAlt = 0;
                        // }
                    }

                    const params = {
                        action: 'imageAlt',
                        selectType: this.props.SelectType,
                        targetId: this.props.TargetId,
                        altKey: JSON.stringify(idArr),
                        altValue: JSON.stringify(altArr),
                        blogId: this.props.editBlogId,
                        collectionType: this.props.editCollectionType
                    };
                    const response = await reqPostmanualBulkEditAction(params)

                    if (response.code === '200') {
                        this.toggleToast(response.msg, false);
                        // if(this.props.flushList!==undefined){
                        //     this.props.flushList(this.props.recordKey,isAllAlt);
                        // }
                        // 关闭弹窗
                        this.handleModalChange();
                        this.props.updateDataList({
                            targetId: this.props.TargetId,
                            altKey: JSON.stringify(idArr),
                            altValue: JSON.stringify(altArr),
                        });
                    } else {
                        // this.toggleToast(response.msg,true);
                        this.setState({
                            isShowEditAltBanner: true,
                            EditAltBannerTip: response.msg
                        })
                    }
                    this.setState({ updateImageLoading: false });
                }
            });

        }
    }

    // 将alt模板应用到所有图片alt中
    applyAll = () => {
        this.setState({
            applyAllLoading: true
        }, () => {
            let { SelectType } = this.props;
            let { defaultTag, resData } = this.state;
            let curTag = cloneDeep(defaultTag);
            curTag = curTag.replace(/\n/g, '');
            if (SelectType === 'product') {
                curTag = curTag
                    .replace(/\[\[{"value":"{{Product title}}"}\]\]/g, resData.title)
                    .replace(/\[\[{"value":"{{Product vendor}}"}\]\]/g, resData.vendor)
                    .replace(/\[\[{"value":"{{Product type}}"}\]\]/g, resData.product_type)
                    .replace(/\[\[{"value":"{{Shop name}}"}\]\]/g, this.props.ShopName);

            } else if (SelectType === 'collections') {
                curTag = curTag
                    .replace(/\[\[{"value":"{{Collection title}}"}\]\]/g, resData.title)
                    .replace(/\[\[{"value":"{{Shop name}}"}\]\]/g, this.props.ShopName);
            } else if (SelectType === 'blog') {
                curTag = curTag
                    .replace(/\[\[{"value":"{{Blog title}}"}\]\]/g, resData.title)
                    .replace(/\[\[{"value":"{{Shop name}}"}\]\]/g, this.props.ShopName);
            } else { }
            if (Boolean(curTag)) {
                let data = cloneDeep(this.state.allImagesArr);
                for (let i = 0; i < data.length; i++) {
                    data[i].alt = curTag;
                }

                this.setState({
                    allImagesArr: data,
                    emptyId: [],
                }, () => {
                    this.updateTableContent();
                });
            } else {
                // this.toggleToast('The input field cannot be empty', false);
                this.setState({
                    tagActive: ["FixTagContent"]
                })
            }
            setTimeout(() => {
                this.setState({
                    applyAllLoading: false
                })
            }, 300)
        })
    }

    // 编辑模板文本
    handleInputChange = (value, id) => {
        this.setState({
            [id]: value
        });
    }

    // 点击变量 将值填充到 input 框内
    handleTagClick = (value, e) => {
        var newValue;
        if (value === 'title') {
            newValue = this.props.Title;
        } else if (value === 'keyword') {
            newValue = this.props.Keyword;
        } else if (value === 'vendor') {
            newValue = this.props.Vendor;
        } else if (value === 'product_type') {
            newValue = this.props.ProductType;
        } else if (value === 'shop_domain') {
            newValue = this.props.ShopName;
        } else if (value === 'buik_template') {
            newValue = this.props.AltTemplate
                .replace(/%product_title%/g, this.props.Title)
                .replace(/%product_vendor%/g, this.props.Vendor)
                .replace(/%product_type%/g, this.props.ProductType)
                .replace(/%shopname%/g, this.props.ShopName)
                .replace(/%price%/g, '')
        }

        var settingValue = '';
        if (newValue !== '') {
            settingValue = ' ' + newValue + ' ';
        } else {
            settingValue = newValue;
        }
        // id 对象 (根据光标的位置插入数据)
        var obj = document.getElementById('applyAllValue');
        var getValue = this.insertAtCursor(obj, settingValue);

        // 处理空格问题
        var r = /\s+/g;
        getValue = getValue.replace(r, ' '); // 连续空格只保留一个
        getValue = getValue.replace(/^\s*|\s*$/g, "");  // 移除两侧空格

        this.setState({
            applyAllValue: getValue
        })
    }

    // 在光标位置插入内容  (文本框对应ID对象,需要添加的值)
    insertAtCursor(myField, myValue) {
        // IE support
        if (document.selection) {
            myField.focus();
            var sel = document.selection.createRange();
            sel.text = myValue;
        }
        // Microsoft Edge
        else if (window.navigator.userAgent.indexOf("Edge") > -1) {
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;

            myField.value = myField.value.substring(0, startPos) + myValue
                + myField.value.substring(endPos, myField.value.length);

            var pos = startPos + myValue.length;
            myField.focus();
            myField.setSelectionRange(pos, pos);
        }
        //MOZILLA and others
        else if (myField.selectionStart || myField.selectionStart === 0) {
            var startPos1 = myField.selectionStart;
            var endPos1 = myField.selectionEnd;
            myField.value = myField.value.substring(0, startPos1)
                + myValue
                + myField.value.substring(endPos1, myField.value.length);
        } else {
            myField.value += myValue;
        }

        return myField.value;
    }

    // 打开选择参数
    openSelectParams = () => {
        this.setState({
            isShowSelectPop: !this.state.isShowSelectPop
        })
    }

    // 选择对应字段
    addApplyField = (type, name) => {
        let { defaultTag } = this.state;
        this.setState({
            defaultTag: !Boolean(defaultTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${defaultTag} [[{"value":"{{${type}}}"}]]`,
            addTagsFix: !Boolean(defaultTag?.length) ? `[[{"value":"{{${type}}}"}]]` : `${defaultTag} [[{"value":"{{${type}}}"}]]`,
            [`${name}Pop`]: !Boolean(this.state[`${name}Pop`]),
            tagActive: [],
        })
        // this.$TagEvent.addInputTag(type);
    }

    // 获取tag输入框对象
    setTagifyData = (data) => {
        this.setState({
            tagSet: data[0],
        })
        this.$TagEvent = data[1];
    }

    // 输入
    tagInputData = (e) => {
        const allowList = [
            "Product title",
            "Product vendor",
            "Product type",
            "Shop name",
            "Collection title",
            "Blog title",
        ]
        let _value = Boolean(e.detail.value) ? e.detail.value.replace(/[\n\u200B]/g, "") : '';
        const formattedValue = utils.normalizeMixValue(_value, allowList);
        this.setState({
            defaultTag: formattedValue,
            tagActive: []
        })
    }

    // 无痕模式 - 输入
    tagInputDataTraceless = (val) => {
        val = this.setDefaultTagFormat(val);
        this.setState({
            defaultTag: Boolean(val) ? val.replace(/[\n\u200B]/g, "") : '',
            tagActive: []
        })
    }

    // 改变tag下拉框状态
    changeSelectPop = (id) => {
        let name = `${id}Pop`;
        this.setState({
            [name]: !Boolean(this.state[name]),
        })
    }

    // 联系客服
    handleContactServiceShow = () => {
        try {
            showNewMessage()
        } catch (e) {
            this.toggleToast(t("Try again later"), true);
        }
    }

    render() {
        const {
            modalActive,
            updateImageLoading,
            imageTbaleTrRow,
            dataLoading,
            defaultTag,
            proTagList,
            colTagList,
            blogTagList,
            applyAllLoading,
            FixTagContentPop,
            addTagsFix,
            isLocalStorage,
            tagActive,
            isShowEditAltBanner,
            EditAltBannerTip,
            isShowErrorTip,

        } = this.state;

        const { SelectType } = this.props;

        const toastMarkup = this.state.showToast ? (
            <ToastFunc
                content={this.state.showToastText}
                onDismiss={this.state.showToast}
                error={this.state.showToastIserror}
            />
        ) : null;

        // 格式数据
        const TracelessTagsData = (data) => {
            let val = cloneDeep(data);
            val = val.replace(/[\n\u200B]/g, '');
            let type = SelectType;
            if (type === 'product') {
                val = val.replace(/\[\[{"value":"{{Product title}}"}\]\]/g, '%product_title%')
                    .replace(/\[\[{"value":"{{Product vendor}}"}\]\]/g, '%product_vendor%')
                    .replace(/\[\[{"value":"{{Product type}}"}\]\]/g, '%product_type%')
                    .replace(/\[\[{"value":"{{Shop name}}"}\]\]/g, '%shop_name%')
            } else if (type === 'collections') {
                val = val.replace(/\[\[{"value":"{{Collection title}}"}\]\]/g, '%collection_title%')
                    .replace(/\[\[{"value":"{{Shop name}}"}\]\]/g, '%shop_name%');
            } else if (type === 'blog') {
                val = val.replace(/\[\[{"value":"{{Blog title}}"}\]\]/g, '%blog_title%')
                    .replace(/\[\[{"value":"{{Shop name}}"}\]\]/g, '%shop_name%');
            } else { }
            return val;
        }

        // alt 选项
        const actionList = SelectType === 'product' ? proTagList : SelectType === 'collections' ? colTagList : SelectType === 'blog' ? blogTagList : [];
        const warnIcon = <svg t="1695125243916" className="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="11078" width="20" height="20"><path d="M959.256366 512C959.256366 264.98713 759.01287 64.743634 512 64.743634 264.98713 64.743634 64.743634 264.98713 64.743634 512 64.743634 759.01287 264.98713 959.256366 512 959.256366 759.01287 959.256366 959.256366 759.01287 959.256366 512L959.256366 512 959.256366 512 959.256366 512 959.256366 512 959.256366 512ZM117.36203 512C117.36203 294.047467 294.047467 117.36203 512 117.36203 729.952533 117.36203 906.63797 294.047467 906.63797 512 906.63797 729.952533 729.952533 906.63797 512 906.63797 294.047467 906.63797 117.36203 729.952533 117.36203 512L117.36203 512 117.36203 512 117.36203 512 117.36203 512 117.36203 512Z" fill="#FC5143" p-id="11079"></path><path d="M484.457558 599.560299C484.457558 622.580963 495.008537 634.091122 516.110812 634.091122 537.213087 634.091122 547.764066 622.580963 547.764066 599.560299L547.764066 280.150193C547.764066 257.129529 537.213087 245.61937 516.110812 245.61937 495.008537 245.61937 484.457558 257.129529 484.457558 280.150193L484.457558 599.560299ZM478.702421 740.561158C480.62081 763.581821 493.090149 775.091981 516.110812 775.091981 539.131476 775.091981 551.600815 763.581821 553.519203 740.561158 551.600815 717.540494 539.131476 705.071155 516.110812 703.152767 493.090149 705.071155 480.62081 717.540494 478.702421 740.561158L478.702421 740.561158Z" fill="#FC5143" p-id="11080"></path></svg>
        const modalContentText = dataLoading ? (
            <div className="DetailReport_Empty_New_div_margin_800">
                <Spinner size="large" color="teal" />
            </div>
        ) : (
            <div>
                <BlockStack align="center" gap={2}>
                    <div className="flex_layout" style={{ marginBottom: '0.2rem', alignItems: 'unset' }}>
                        <div style={{ flex: 10, maxWidth: '90%' }}>
                            {
                                Boolean(isLocalStorage) ? <>
                                    <FreeTagInputMix
                                        id={"FixTagContent"}
                                        defaultTag={defaultTag}
                                        actionList={actionList}
                                        tagActive={tagActive}
                                        isShowSelectPop={FixTagContentPop}
                                        changeSelectPop={this.changeSelectPop}
                                        tagInputData={this.tagInputData}
                                        addTags={addTagsFix}
                                        hiddenAddBtn={SelectType === 'otherpage'}
                                    />
                                    {
                                        (tagActive.length > 0 && tagActive.includes("FixTagContent")) ? <div className='flex_layout warnTip'>
                                            {warnIcon}
                                            <span>{t("The input cannot be empty!")}</span>
                                        </div> : null
                                    }
                                </> : <FreeTagInputTraceless
                                    id={"FixTagContent"}
                                    defaultTag={TracelessTagsData(defaultTag)}
                                    actionList={actionList}
                                    tagActive={tagActive}
                                    isShowSelectPop={FixTagContentPop}
                                    changeSelectPop={this.changeSelectPop}
                                    tagInputDataTraceless={this.tagInputDataTraceless}
                                    hiddenAddBtn={SelectType === 'otherpage'}
                                />
                            }
                        </div>
                        <div className="apply_alt_btn"><Button loading={applyAllLoading} onClick={this.applyAll}>{t("Apply")}</Button></div>
                    </div>
                </BlockStack>
                <div className="width_th_15 minHeight_alt">
                    <DataTable
                        columnContentTypes={[
                            'text',
                            'text',
                        ]}
                        headings={[
                            t("Image"),
                            t("Alt text"),
                        ]}
                        verticalAlign="middle"
                        rows={imageTbaleTrRow}
                    />
                </div>
            </div>)

        const modalContent = (
            <Modal
                // size='large'
                open={modalActive}
                onClose={this.handleModalChange}
                title={t("Image Alt Edit")}
                primaryAction={{
                    loading: updateImageLoading,
                    content: t("Save"),
                    onAction: this.updateImageAlt,
                }}
                secondaryActions={[
                    {
                        content: t("Close"),
                        onAction: this.handleModalChange,
                    },
                ]}
            >
                <Modal.Section>
                    <BlockStack gap={400}>
                        {
                            isShowEditAltBanner && <Banner
                                title={EditAltBannerTip}
                                tone="warning"
                                onDismiss={() => {
                                    this.setState({ isShowEditAltBanner: false })
                                }}
                            >
                            </Banner>
                        }
                        {
                            isShowErrorTip && <Banner
                                title={isShowErrorTip}
                                tone="critical"
                                onDismiss={() => {
                                    this.setState({ isShowErrorTip: '' })
                                }}
                                action={{
                                    content: t("Contact us"),
                                    onAction: this.handleContactServiceShow
                                }}
                            >
                            </Banner>

                        }
                        {modalContentText}
                    </BlockStack>
                </Modal.Section>
            </Modal>
        )

        return (
            <div className="ImageAltEdit_Modal">
                {modalContent}
                {toastMarkup}
            </div>
        );
    }
}

export default OptimizeImageAlt;